"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
var $ = require("jquery");
var Page_1 = require("../../../core/Page");
require("backbone.layoutmanager");
require("bootstrap-slider");
require("../../../../styles/specific/static/Tabs.css");
var React = require("react");
function updateSizes() {
    var closedTabCount = $('.slider-open ~ .slider-closed').length;
    closedTabCount = Math.min(closedTabCount, 3);
    var height = Page_1.default.getTabContentHeight() - closedTabCount * Page_1.default.getTabHeaderHeight();
    clearSizes();
    $('.slider-open .slider-content').css('min-height', height);
    $('.slider-open .slider-wrapper').css('height', height);
}
function clearSizes() {
    $('.slider-content').css('min-height', '');
    $('.slider-wrapper').css('height', '');
}
var Wide = /** @class */ (function (_super) {
    __extends(Wide, _super);
    function Wide() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'Wide';
        return _this;
    }
    Wide.prototype.componentWillUnmount = function () {
        var app = this.props.app;
        Page_1.default.off('update', updateSizes);
        app.enableScroll();
    };
    Wide.prototype.componentDidMount = function () {
        var app = this.props.app;
        var scrollContainer = $('.scroll-container');
        var createAfter = function (content) {
            return function () {
                app.disableScroll();
                _.defer(updateSizes);
                $(content).css('overflow', 'auto');
            };
        };
        var props = this.props;
        var refs = this.refs;
        if (props.view) {
            $(refs.wrapper).append(props.view.$el);
            props.view.render();
            props.view.delegateEvents();
        }
        Page_1.default.on('update', updateSizes);
        $('.slider-closed .slider-wrapper').hide();
        $('.slider-content .title-wrapper').click(function () {
            var outer = $(this).parent();
            if (outer.hasClass('slider-open')) {
                if (outer.prev('.slider-content').length) {
                    outer.children('.slider-wrapper').slideUp(function () {
                        outer.find('.slider-wrapper').css('overflow', '');
                        var $sliderOpen = outer.parent().children('.slider-content').first();
                        $sliderOpen.children('.slider-wrapper').slideDown(function () {
                            scrollContainer.scrollTo($sliderOpen.offset().top - $('.main-row').offset().top, {
                                duration: 200,
                                onAfter: createAfter($sliderOpen.find('.slider-wrapper')),
                                axis: 'y'
                            });
                        });
                        $sliderOpen.removeClass('slider-closed').addClass('slider-open');
                    });
                    outer.removeClass('slider-open').addClass('slider-closed');
                }
            }
            else {
                outer.children('.slider-wrapper').slideDown(function () {
                    var sliderOpen = $('.slider-open');
                    app.disableScroll();
                    scrollContainer.scrollTo(sliderOpen.offset().top - $('.main-row').offset().top, {
                        duration: 200,
                        onAfter: createAfter(sliderOpen.find('.slider-wrapper')),
                        axis: 'y'
                    });
                });
                outer.removeClass('slider-closed').addClass('slider-open');
                $('.slider-open').not(outer).each(function () {
                    var wrapper = $(this).children('.slider-wrapper');
                    wrapper.slideUp(function () {
                        wrapper.css('overflow', '');
                    });
                    $(this).removeClass('slider-open').addClass('slider-closed');
                });
            }
        });
        var sliderOpen = $('.slider-open');
        if (sliderOpen.length) {
            app.disableScroll();
            scrollContainer.scrollTo(sliderOpen.offset().top - $('.main-row').offset().top, {
                duration: 200,
                onAfter: createAfter(sliderOpen.find('.slider-wrapper')),
                axis: 'y'
            });
        }
    };
    Wide.prototype.render = function () {
        return React.createElement("div", { className: "layout layout-wide" },
            React.createElement("div", { className: "col-md-12 main-content-page" },
                React.createElement("div", { className: "visible-xs visible-sm header-fill" }),
                React.createElement("div", { className: "row-fluid" },
                    React.createElement("div", { className: "col-md-12 main-content-wrapper", ref: "wrapper" }))));
    };
    Wide.identifierClass = 'layout-wide';
    Wide.layoutName = 'Wide';
    return Wide;
}(React.Component));
exports.default = Wide;
//# sourceMappingURL=Wide.js.map


//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/layouts/Wide.js
// module id = 832
// module chunks = 1